import { ThemeToggle } from "./ThemeToggle";
import type { ThemeButton, ThemePreference } from "../theme/theme";

export function Header({
  preference,
  onThemeClick,
}: {
  preference: ThemePreference;
  onThemeClick: (button: ThemeButton) => void;
}) {
  return (
    <header className="flex items-center justify-between border-b border-[var(--border)] px-4 py-3">
      <span className="font-semibold">PairDrop</span>
      <ThemeToggle preference={preference} onClick={onThemeClick} />
    </header>
  );
}
